import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye mi compra?',
  a: 'Los dos libros digitales completos de Murdoku, con 80 acertijos en cada uno y 160 desafíos en total.'
}, {
  q: '¿El producto es físico?',
  a: 'No. Es un producto 100 % digital y no se realiza ningún envío físico.'
}, {
  q: '¿Cómo recibo los libros?',
  a: 'Después de completar el pago recibirás el acceso para descargarlos.'
}, {
  q: '¿Incluyen las soluciones?',
  a: 'Sí. Ambos libros incluyen sus respectivas soluciones.'
}];
export const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="max-w-3xl mx-auto space-y-4" data-id="element-143" data-mp="2k9qdaycz4tr5">
      {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-144" data-mp="uth9hgdd88zh" data-mpi={index}>
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-145" data-mp="pv7d52fwn2ca">
            <span className="font-heading font-bold text-murdoku-dark text-xl tracking-wide" data-id="element-146" data-mp="33wcb3quejp44">
              {faq.q}
            </span>
            <ChevronDown className={`text-murdoku-orange transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-147" data-mp="38t2qsd2aoip0" />
          </button>
          <AnimatePresence data-id="element-148" data-mp="3il01lipe58n7">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-149" data-mp="3imb9nupvd2k4">
                <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-150" data-mp="e27o8l18kdf">{faq.a}</div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
};